module.exports = __webpack_public_path__ + "static/assets/13788cd19d244a752bb8edf63f7d1c24.jpg";